export default __webpack_public_path__ + "static/media/EXEMPLO 7.61e95619.jpg";